<template>
  <div class="registered-exams-report">
    <form @submit.prevent.stop="submitToGetReport">
      <div class="registered-exams-report__card">
        <h3>FILTROS</h3>
        <span class="registered-exams-report__label">Período*</span>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout
            md-flex="45"
            md-flex-medium="45"
          >
            <div class="date-range-container">
              <DatePickerRange
                :date-selected.sync="date"
                :date-filter-alternative="true"
                :limit-data="limitData"
                :default-start-date="defaultStartDate"
                :default-end-date="defaultEndDate"
                :calendar-direction="'bottom'"
                :clear-button="false"
              />
            </div>
          </md-layout>
        </md-layout>

        <h3>Status</h3>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout md-flex="100">
            <md-radio
              v-model="reportData.status"
              :md-value="'CADASTRADO'"
            >
              CADASTRADO
            </md-radio>
            <md-radio
              v-model="reportData.status"
              :md-value="'FINALIZADO'"
            >
              LIBERADO
            </md-radio>
          </md-layout>
        </md-layout>

        <h3 class="mt-5">
          Exportar como
        </h3>
        <md-layout
          :md-gutter="24"
          md-flex="100"
        >
          <md-layout md-flex="100">
            <md-radio
              v-model="reportData.exportWay"
              :md-value="'XLSX'"
            >
              EXCEL
            </md-radio>
            <md-radio
              v-model="reportData.exportWay"
              :md-value="'PDF'"
            >
              PDF
            </md-radio>
          </md-layout>
        </md-layout>
      </div>
      <div class="registered-exams-report__box-submit">
        <button
          v-if="!needsToWait"
          class="btn btn-primary btn-regular-size"
          type="submit"
        >
          Gerar relatório
        </button>
        <button
          v-else
          class="btn btn-primary btn-regular-size spinner"
        >
          <Spinner />
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import DatePickerRange from '@/components/common/DatePickerRange'
import { formartDateFromArray } from '@/utils/date-utils'
import Moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import reportRegisteredExamsService from '@/api/reportRegisteredExams'
import { downloadFileByByteArray } from '@/utils/convertByteArrayToFile'
import Spinner from '@/components/common/Spinner'

export default {
  name: 'RegisteredExamsReport',
  components: {
    DatePickerRange,
    Spinner
  },
  data: () => {
    return {
      reportData: {
        laboratoryId: null,
        releaseDateStart: null,
        releaseDateEnd: null,
        exportWay: 'XLSX',
        status: 'CADASTRADO'
      },
      date: {
        start: new Date(),
        end: new Date()
      },
      limitDays: 120,
      needsToWait: false
    }
  },
  computed: {
    ...mapGetters(['profile', 'getTodayDate']),
    today: function () {
      return formartDateFromArray(this.getTodayDate)
    },
    defaultStartDate: function () {
      return this.today
    },
    defaultEndDate: function () {
      return this.today
    },
    limitData: function () {
      let today = formartDateFromArray(this.getTodayDate)
      return Moment(today, 'DD/MM/YYYY').subtract(this.limitDays, 'days').toDate()
    }
  },
  watch: {
    date: function (newTime) {
      this.reportData.releaseDateStart = Moment(newTime.start).format()
      this.reportData.releaseDateEnd = Moment(newTime.end).format()
    }
  },
  created() {
    this.updateToday()
  },
  methods: {
    ...mapActions(['updateToday']),
    submitAnalyticsEvent(data) {
      this.$analytics.pushAnalyticsEvent('ga-send', 'event', {
        category: 'Gerar relatórios',
        action: 'Gerar relatório - Remarcação',
        period: data.releaseDateStart + 'Até' + data.releaseDateEnd,
        format: data.exportWay,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    getReport() {
      this.needsToWait = true
      reportRegisteredExamsService
        .getRegisteredExamsReport(this.reportData)
        .then(response => {
          const fileName = response.headers['content-disposition'].split('filename=')[1]
          const fileExtension = response.headers['content-type']
          downloadFileByByteArray(response.data, fileName, fileExtension)

          this.needsToWait = false
        })
        .catch(() => {
          this.$emit('noResultsFound')
          this.needsToWait = false
        })

      this.submitAnalyticsEvent(this.reportData)
    },
    submitToGetReport(e) {
      e.preventDefault()

      if (!this.reportData.releaseDateStart && !this.reportData.releaseDateEnd) {
        this.reportData.releaseDateStart = Moment(this.date.start).format()
        this.reportData.releaseDateEnd = Moment(this.date.end).format()
      }

      const valueOnInput = document.getElementById('dateFilter').value
      const valueSelected = this.reportData.releaseDateStart + ' - ' + this.reportData.releaseDateEnd

      if (valueOnInput !== 'Hoje' && valueOnInput !== valueSelected) {
        this.reportData.releaseDateStart = Moment(this.date.start).format()
        this.reportData.releaseDateEnd = Moment(this.date.end).format()
      }

      this.reportData.laboratoryId = this.profile.id_laboratory

      this.getReport()
    }
  }
}
</script>

<style lang="scss">
  .registered-exams-report {
    width: 100%;
    font-family: 'Exo 2' !important;

    &__card {
      padding: 16px 20px 20px;
      background-color: #fff;
      position: relative;
      transition: min-height 0.6s, opacity 0.6s;
      opacity: 1;
      border-radius: 6px;
      margin-top: 15px;
      .md-layout {
        flex-wrap: nowrap;
      }
    }

    &__box-submit {
      display: flex;
      justify-content: flex-end;

      button {
        margin-top: 56px;
        font-family: 'Exo 2' !important;

        &.spinner {
          pointer-events: none;

          .loader {
            font-size: 3px;
            border-color: rgba(255, 255, 255, 0.2);
            border-left: 1.1em solid #fff;
          }
        }
      }
    }

    &__label {
      display: block;
      color: #7f1b54;
      font-size: 12px;
      margin-bottom: -20px;
      margin-top: 15px;
      font-weight: 500;
    }

    h3 {
      font-size: 12px;
      letter-spacing: 0.1px;
      text-align: left;
      color: #7f1a54;
      font-weight: 600;
      text-transform: uppercase;
    }

    input {
      font-size: 14px !important;
      color: #303030 !important;
    }

    .date-range-container {
      width: 100%;

      .search-bar__date {
        margin: 0;
      }

      #datePickerSelect {
        &::after {
          content: ' ';
          height: 1px;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.12);
          position: absolute;
          left: 0;
          transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
          background-color: #d3d3d3 !important;
          border-bottom: none !important;
          display: block !important;
        }

        input {
          color: #303030;
          overflow: hidden;
          font-size: 14px !important;
        }

        input::placeholder {
          color: red;
          text-align: left;
          font-size: 12px !important;
        }
      }
    }

    .md-radio {
      margin-right: 2em;
      margin-bottom: 0;

      .md-radio-container {
        background-color: #ebebeb;
        border: 2px solid #ebebeb;
      }
    }

    .md-theme-default.md-radio.md-checked .md-radio-container {
      background-color: #ebebeb;
      border: 2px solid #ebebeb;
    }

    .md-radio-label {
      color: #7a7a7a;
      text-align: left;
      font-size: 12px;
      font-weight: 500;
      padding-bottom: 10px;
      letter-spacing: 0.8px;
    }

    .md-theme-default.md-radio .md-radio-container::after {
      background-color: #7f1a54;
      transform: scale3D(1.2, 1.2, 1.2);
    }

    input[type='number']::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
    }
    input[type='number'] {
      -moz-appearance: textfield !important;
      appearance: textfield !important;
    }
  }
</style>
